import React, { useState, useEffect } from 'react';
import I18n from 'utils/I18n';
import PropTypes from 'prop-types';

import styles from './index.scss';
import DisclaimerText from '../DisclaimerText';

import SignupAgeGateModal from '../SignupAgeGateModal';

import {
  FacebookButton,
  GoogleButton,
  EmailButton,
  SIGN_UP,
  FACEBOOK,
  GOOGLE,
  EMAIL,
  APPLE,
  elemAttrForAnalytics
} from '../AccountAuthButton';
import AppleButton from '../AccountAuthButton/AppleButton';
import useAppleAuthSignin from '../hooks/useAppleAuthSignin';

import {
  LANDING_PAGE,
  PRIVATE_ACTIVITY,
  MOBILE_REGISTRATION_PAGE,
  pageAttrForAnalytics,
  trackV2Onboarding
} from '../../../utils/onboarding';

const AccountSignupForm = ({ authorizationUrls, config, locale, page }) => {
  const [openModal, setOpenModal] = useState(false);
  const [option, setOption] = useState(null);

  const { signin: appleSignin } = useAppleAuthSignin(config.appleState);

  const I18nPrefix = 'strava.landing_page';

  useEffect(() => {
    trackV2Onboarding({
      page: pageAttrForAnalytics(page),
      action: 'screen_enter'
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnClick = (clickedOption) => {
    trackV2Onboarding({
      page: pageAttrForAnalytics(page),
      action: 'click',
      element: elemAttrForAnalytics(clickedOption)
    });
    setOption(clickedOption);
    if (clickedOption === EMAIL && page !== MOBILE_REGISTRATION_PAGE) {
      const url = authorizationUrls[EMAIL];
      const separator = url.indexOf('?') === -1 ? '?' : '&';
      window.location.href = url.concat(separator).concat('v2=true');
      return;
    }
    setOpenModal(true);
  };

  const handleModalDobSubmit = () => {
    setOpenModal(false);
    if (option === APPLE) {
      appleSignin(config.appleState);
    } else {
      window.location.href = authorizationUrls[option];
    }
  };

  const orDivider = (
    <div className={styles.hr}>
      <div className={styles.hrText}>{I18n.t(`${I18nPrefix}.or`)}</div>
    </div>
  );

  return (
    <>
      <FacebookButton type={SIGN_UP} onClick={() => handleOnClick(FACEBOOK)} />
      <GoogleButton type={SIGN_UP} onClick={() => handleOnClick(GOOGLE)} />
      {config.appleEnabled && (
        <AppleButton type={SIGN_UP} onClick={() => handleOnClick(APPLE)} />
      )}
      {page === LANDING_PAGE && orDivider}
      <EmailButton type={SIGN_UP} onClick={() => handleOnClick(EMAIL)} />
      <DisclaimerText showLoginOption={page === LANDING_PAGE} />
      {page === PRIVATE_ACTIVITY && orDivider}
      <SignupAgeGateModal
        open={openModal}
        onDismissCallback={() => {
          setOpenModal(false);
        }}
        locale={locale}
        onSuccessCallback={handleModalDobSubmit}
        page={page}
      />
    </>
  );
};
AccountSignupForm.propTypes = {
  page: PropTypes.oneOf([
    LANDING_PAGE,
    PRIVATE_ACTIVITY,
    MOBILE_REGISTRATION_PAGE
  ]).isRequired,
  config: PropTypes.shape({
    appleEnabled: PropTypes.bool.isRequired,
    appleState: PropTypes.string.isRequired // https://developer.apple.com/documentation/sign_in_with_apple/clientconfigi/3230956-state
  }).isRequired,
  authorizationUrls: PropTypes.shape({
    google: PropTypes.string.isRequired,
    facebook: PropTypes.string.isRequired
  }).isRequired,
  locale: PropTypes.string.isRequired
};

export default AccountSignupForm;
